export default __webpack_public_path__ + "static/media/interior_black.f6b1b8ad.png";